import Model, { ID } from 'src/models/model'
export default class MeerkatMovie extends Model {
  static name = 'MeerkatMovie'

  static noId = true

  static define () {
    this.fields = {
      valid: {
        type: Boolean,
        default: false,
        output: true
      },
      error: {
        type: String,
        default: null,
        output: true
      },
      pinCode: {
        type: String,
        default: null
      },
      movieEdiCode: {
        type: String,
        default: null,
        input: true
      },
      voucherId: {
        type: ID,
        default: null,
        output: true
      }
    }
  }
}
